module.exports = "/img/city-tokyo.b26bae94.jpg";